var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"collapse-demo"}},[_c('collapse-default'),_c('collapse-accordion'),_c('collapse-type'),_c('collapse-open-hover'),_c('collapse-change-arrow-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }